module.exports = __webpack_public_path__ + "static/media/OurProduct-TealBlockVertical.ffca1fd2.svg";